<template>
  <div>
    <el-dialog title="导出列表" width="30%" :visible.sync="exportVisible" class="abow_dialog">
      <div class="export-list">
        您的导出文件正在生成，请前往 <span style="cursor: pointer;color: #1F61E4" @click="openList">导出列表</span> 进行下载
      </div>
      <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="exportVisible = false">确定</el-button>
    </span>
    </el-dialog>
    <ExportList ref="ExportList"/>
  </div>
</template>

<script>
import ExportList from "./export-list"

export default {
  components: {ExportList},
  data() {
    return {
      exportVisible: false,
    }
  },
  methods: {
    open(params) {
      this.exportVisible = true
      // this.$axios.get(params.url).then(res=>{
      //
      // })
    },
    openList() {
      this.$refs.ExportList.open();
      this.exportVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.export-list {
  height: 60px;
  display: flex;
  align-items: center;
  padding-left: 10px;
}
</style>
